/**
 * Local accordion toggles for sidebar/secondary nav items.
 */
(function ($) {
  "use strict";

  var TOGGLE_SELECTOR = ".js-nav-item-toggle";
  var OPEN_CLASS = "sub-nav-open";

  var toggleNavItem = function (e) {
    e.preventDefault();

    var $button = $(e.currentTarget);
    var $parentNode = $button.closest("li");
    var $submenu = $parentNode.children("ul");

    if (!$submenu.length) {
      return;
    }

    $parentNode.toggleClass(OPEN_CLASS);

    if ($parentNode.hasClass(OPEN_CLASS)) {
      $button.attr("aria-expanded", "true").addClass("is-expanded");
      $submenu.attr("aria-expanded", "true").show();
    } else {
      $button.attr("aria-expanded", "false").removeClass("is-expanded");
      $parentNode.find("li").removeClass(OPEN_CLASS);
      $parentNode.find("ul").attr("aria-expanded", "false").hide();
    }
  };

  $(document).on("click", TOGGLE_SELECTOR, toggleNavItem);
})(jQuery);
